const common = {
  verifyToken: () => 'account/auth/token/verify/',
  refreshToken: () => 'account/auth/token/refresh/',
  LOGOUT: `account/auth/logout/`
}

export const utilUrls = { common }
